import request from '@/utils/request'

export default {

  chatbotWelcome: (params) => {
    return request.get('/chatbot/welcome-trigger/', { params })
  },
  chatbotWelcomeBack: (jobId) => {
    return request.get(`/chatbot/welcome-back-trigger/${jobId}/`)
  },
  chatbotStayJobDetail: (jobId) => {
    return request.get(`/chatbot/stay-job-detail-trigger/${jobId}/`)
  },
  chatbotClickApplyJobButton: (jobId) => {
    return request.get(`/chatbot/click-apply-job-button-trigger/${jobId}/`)
  },
  chatbotOperationChatWindow: (params) => {
    return request.get('/django_rest/chatbot/operation-chat-window/', { params })
  },
  chatbotManagementInfo: () => {
    return request.get('/django_rest/chatbot-management/')
  }
}
